declare const globalJson: any;
declare const window: any;

import { Injectable, InjectionToken } from '@angular/core';
import { useCallback } from 'react';

export let CONSTANTS = new InjectionToken('app.constants');
let SERVER_DATA = window.SERVER_DATA;

export interface IConstants {
  ORGANIZATION_ID: string;
  ORGANIZATION_NAME: string;
  ORGANIZATION_ADDRESS: string;
  ORGANIZATION_EMAIL: string;
  USER_ID: string;
  USER_EMAIL: string;
  USER_FIRST_NAME: string;
  USER_LAST_NAME: string;
  USER_FULL_NAME: string;
  USER_MOBILE_NUMBER: string;
  USER_DOB: string;
  USER_GENDER: string;
  USER_ROLE: string;
  USER_LOCATION_ACCESS: boolean;
  USER_VIBRATION_ACCESS: boolean;
  USER_IS_FIRST_LOGIN: boolean;
  USER_IDENTITY_ID: string;
  USER_ORGANIZATION_TYPE: string;
  USER_ORGANIZATION_ROLE: string;
  USER_GOV_ID: string;
  USER_PROFILE_PICTURE: string;
  WEB_API_TOKEN: string;
  WEB_SOCKET_TOKEN: string;
  WEB_API_URL: string;
  GOOGLE_RECAPTCHA_SITEKEY: string;
  TIMEOUT: number;
  POSTCALL_TIMEOUT: number;
  CLIENT_ID: string;
  USER_IS_ADMIN: boolean;
  COUNTRY_ID: number;
  IMAGES_PATH: string;
  Aumye: string;
  AumyeId: string;
}
export let Constants: IConstants = {
  ORGANIZATION_ID: null,
  ORGANIZATION_NAME: null,
  ORGANIZATION_ADDRESS: null,
  ORGANIZATION_EMAIL: null,
  USER_IS_ADMIN: false,
  USER_ID: null,
  USER_EMAIL: null,
  USER_LOCATION_ACCESS: true,
  USER_FIRST_NAME: null,
  USER_LAST_NAME: null,
  USER_FULL_NAME: null,
  USER_MOBILE_NUMBER: null,
  USER_DOB: null,
  USER_GENDER: null,
  USER_ROLE: null,
  USER_IS_FIRST_LOGIN: false,
  USER_VIBRATION_ACCESS: false,
  USER_IDENTITY_ID: null,
  USER_ORGANIZATION_TYPE: null,
  USER_ORGANIZATION_ROLE: null,
  USER_GOV_ID: null,
  USER_PROFILE_PICTURE: null,
  WEB_API_TOKEN: null,
  WEB_SOCKET_TOKEN: null,
  WEB_API_URL: null,
  GOOGLE_RECAPTCHA_SITEKEY: null,
  TIMEOUT: 240000,
  POSTCALL_TIMEOUT: 360000,
  CLIENT_ID: 'TechCyclops',
  COUNTRY_ID: null,
  IMAGES_PATH: null,
  Aumye: null,
  AumyeId: null,
};
@Injectable()
export class ConstantSetterAndGetterService {
  constructor() {}

  setConstants(val: IConstants) {
    Constants = val;
  }

  getConstants() {
    return Constants;
  }
}
